import { RestrictionDetailsModalRestrictionsDetailsCardsProps } from '../props';
import styles from './styles.module.scss';
import { FormGroup } from '@starsoft/common/components';
import useTranslation from 'next-translate/useTranslation';

export default function RestrictionDetailsModalRestrictionsDetailsDuration({
  restriction,
}: RestrictionDetailsModalRestrictionsDetailsCardsProps) {
  const { t } = useTranslation('common');
  return (
    <FormGroup label={t('restriction_details_duration_label')}>
      <div className={styles.container}>
        <i
          className={`${styles.container__icon} fa-solid fa-hourglass-start`}
        />
        <p className={styles.container__label}>
          {restriction?.duration}{' '}
          {t(
            `account:${restriction?.frameId}_frame_label${restriction?.duration > 1 ? '_plural' : ''}`,
          )}
        </p>
      </div>
    </FormGroup>
  );
}
